import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_b9ze9cg9: FaireBrandEntity = {
  token: "b_b9ze9cg9",
  type: "brand",
  name: "Etc. Letterpress",
  avatarUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/c04f57715f32e4b1b3845600a630358dec5f4e7f569ed77dab5573abda569ad6/1545938932.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/237dd9aa6999e7d7aefe0da6206fffdc44ec0f2b9d02eee739f6bcecb93afaa3.jpeg",
  logoUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/c04f57715f32e4b1b3845600a630358dec5f4e7f569ed77dab5573abda569ad6/1545938932.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/237dd9aa6999e7d7aefe0da6206fffdc44ec0f2b9d02eee739f6bcecb93afaa3.jpeg",
  location: "Santa Fe, NM, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 18,
  isTopShop: true,
  isInsider: true,
  description:
    "Etc. Letterpress was born out of a love for heartfelt sentiments, vintage typefaces, and luxurious paper. All hand-set cards are composed the old-fashioned way using lead and wood type and are printed in sunny New Mexico on antique presses. A love for these machines and the materials of printing has kept Etc. Letterpress busy with custom job printing and this little line of cards to suit any occasion!",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:08.497Z",
    importedBy: "entity-db-cli",
  },
};
